/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {cancelStockSplitJob} from '../api'

export const useMutationCancelStockSplitJob = createReactQueryMutationHook('cancelStockSplitJob', cancelStockSplitJob)
